import { Text } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: ${pxToRem(24)};
  width: 100%;
  max-width: ${pxToRem(320)};
`;

export const NotificationGroupTitle = styled(Text)`
  ${({ theme: { typography } }) => typography.fds_text_regular_L};
  background: ${({ theme: { colors } }) => colors.moon_300};
  padding: ${({ theme: { sizing } }) => `${sizing.fds_size_08} ${sizing.fds_size_24}`};
`;
